import { render, staticRenderFns } from "./riskVariableUsed.vue?vue&type=template&id=c4554b8e&scoped=true"
import script from "./riskVariableUsed.vue?vue&type=script&lang=js"
export * from "./riskVariableUsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4554b8e",
  null
  
)

export default component.exports